<script setup>
import { computed } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})

const cardClass = computed(() =>
  cn(
    'rounded-lg border bg-white text-gray-950',
    props.class
  )
)
</script>

<template>
  <div :class="cardClass">
    <slot />
  </div>
</template>
